const M = window.M

const eventMap = {
  onhide: [], // M.page.html을 통해 이동시, 그전에 호출되는 이벤트 (비동기는 보장하지않는다.)
  onrestore: [], // M.page.html을 통해 이동된 화면에서 다시 현재페이지로 넘어올때
  onback: [], // 안드로이드 물리 백키 클릭시 콜백
  onpause: [], // 백그라운드 상태로 빠질때
  onresume: [], // 포그라운드 상태로 돌아올때
}

export const addLifecycle = (type, callback) => {
  const arr = eventMap[type]
  if (!arr) throw new Error(type + '은 존재하지 않는 라이프사이클입니다.')
  arr.push(callback)
}

export const removeLifecycle = (type, callback) => {
  const arr = eventMap[type]
  if (!arr) throw new Error(type + '은 존재하지 않는 라이프사이클입니다.')
  const exist = arr.indexOf(callback)
  if (exist > -1) {
    arr.splice(exist, 1)
  }
}

M.onHide(function (e) {
  eventMap.onhide.forEach((fn) => fn())
})

M.onRestore(function (e) {
  eventMap.onrestore.forEach((fn) => fn())
})

M.onBack(function (e) {
  eventMap.onback.forEach((fn) => fn())
})

M.onResume(function (e) {
  eventMap.onresume.forEach((fn) => fn())
})

M.onPause(function (e) {
  eventMap.onpause.forEach((fn) => fn())
})
